import { Component, OnInit } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  username: string;
  admin: boolean;

  constructor(private keycloakService: KeycloakService) {
  }

  ngOnInit() {
    this.username = this.keycloakService.getUsername();
    this.admin = this.keycloakService.isUserInRole('admin');
  }

  logout() {
    this.keycloakService.logout();
  }

  accountManagement() {
    this.keycloakService.getKeycloakInstance().accountManagement();
  }

}
